import { combineReducers } from "redux";
import settings from "./settings/reducer";
import menu from "./menu/reducer";
import authUser from "./auth/reducer";
import cart from "./cart/reducer";

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  cart,
});

export default reducers;
